import { useQuery } from '@tanstack/react-query';

import { useRequestListagem } from 'hooks/useRequestListagem';
import { ConfiguracaoGeral } from 'pages/revendedor/configuracao-geral/types';

export function useQueryConfigGeral() {
    const requestListagem = useRequestListagem();

    return useQuery<ConfiguracaoGeral>(
        ['queryConfigGeral'],
        () => requestListagem({ url: '/gestao/revendedordesconto/ativo' }).then((res) => res.data.data),
        {
            enabled: true,
        },
    );
}
